import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';

export default function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <motion.button
            type="button"
            onClick={toggleTheme}
            whileTap={{ scale: 0.92 }}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
            className="relative flex h-10 w-10 items-center justify-center overflow-hidden rounded-full
                       border border-slate-200 text-slate-600 transition-colors hover:bg-slate-100
                       dark:border-white/10 dark:text-slate-300 dark:hover:bg-white/[0.06]"
        >
            <AnimatePresence mode="wait" initial={false}>
                <motion.span
                    key={theme}
                    initial={{ y: 12, opacity: 0, rotate: -30 }}
                    animate={{ y: 0, opacity: 1, rotate: 0 }}
                    exit={{ y: -12, opacity: 0, rotate: 30 }}
                    transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
                    className="absolute"
                >
                    {isDark ? <FiMoon size={17} aria-hidden="true" /> : <FiSun size={17} aria-hidden="true" />}
                </motion.span>
            </AnimatePresence>
        </motion.button>
    );
}
